module.exports = __webpack_public_path__ + "static/kmnWeb-9d9397f7267666b5f8704809f1ad6045.png";